import React from 'react';
import { isElementOfType } from './isElementOfType';
import { CoreUITypedComponent } from './types/CoreUITypedComponent';

export const isValidElementOfType = <TProps, TType extends string>(
  obj: unknown,
  type: TType,
): obj is React.ReactElement<TProps, CoreUITypedComponent<TProps, TType>> =>
  typeof obj === 'object' && React.isValidElement(obj) && isElementOfType(obj.type, type);
